import form from './index.js'

// 获取代金券  /welfare/userGift
export function getvouchers(data) {
    return form.getrequest('/welfare/getCoupon', data)
}

// 获取已领取代金券  /welfare/userGift
export function getvouchersed(data) {
    return form.getrequest('/welfare/userCoupon', data)
}

//领取代金券 /welfare/productGift
export function getvouchersnum(data) {
    return form.postrequest('/welfare/productCoupon', data)
}

//查询值 /welfare/productGift
export function getAppModuleCon(data) {
    return form.getrequest('/welfare/getAppModuleCon', data)
}

//获取月卡引导卡信息 /monthCard/getMonthCardInfo
export function getMonthCardInfo(data) {
    return form.getrequest('/monthCard/getMonthCardInfo', data)
}